import { useDrag } from "client/hooks/utils/useDrag";
import { setActiveTextBoxId, setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { getMeme } from "store/features/memeGenerator/utils/getMeme";
import {
    calculateCenterPosition,
    calculateSPosition,
    convertFixedXToRelativeX,
    convertFixedYToRelativeY,
} from "store/features/memeGenerator/utils/useResizeHandlers";
import { store, useAppDispatch } from "store/store";
import { useMemeEditor } from "../../../MemeEditorContext";

export const useRotateHandler = (textBox: TextBox) => {
    const dispatch = useAppDispatch();
    const { itemsContainerRef } = useMemeEditor();

    function onPointerDown() {
        dispatch(
            setSettings({
                id: textBox.id,
                draggingState: {
                    rotate: true,
                },
            }),
        );
    }

    function onPointerMove(clientX: number, clientY: number) {
        const meme = getMeme();
        const container = {
            left:
                itemsContainerRef?.current?.getBoundingClientRect().left ||
                0 + meme.settings.image.left + meme.settings.itemsContainer.left,
            top:
                itemsContainerRef?.current?.getBoundingClientRect().top ||
                0 + meme.settings.image.top + meme.settings.itemsContainer.top,
        };
        const _textBox = store.getState().memeGenerator.meme?.textBoxes.find((_t) => _t.id === textBox.id);
        if (!_textBox) return;
        const [cX, cY] = calculateCenterPosition(textBox);
        const [eX, eY] = [convertFixedXToRelativeX(clientX, container), convertFixedYToRelativeY(clientY, container)];
        const [sX, sY] = calculateSPosition(textBox);
        const [reX, reY] = [eX - cX, cY - eY];
        const [rsX, rsY] = [sX - cX, cY - sY];
        const angleCE = (Math.atan2(reY, reX) * 180) / Math.PI;
        const angleCS = (Math.atan2(rsY, rsX) * 180) / Math.PI;
        const diff = angleCS - angleCE - 13;
        dispatch(
            setSettings({
                id: textBox.id,
                rotation: textBox.rotation + diff,
            }),
        );
        store.getState().memeGenerator.meme?.activeTextBoxId !== textBox.id && dispatch(setActiveTextBoxId(textBox.id));
    }

    function onPointerUp() {
        setTimeout(() => {
            dispatch(
                setSettings({
                    id: textBox.id,
                    draggingState: {
                        rotate: false,
                    },
                }),
            );
        }, 50);
    }

    const { dragHandlers, isDragging } = useDrag({
        onPointerDown,
        onPointerMove,
        onPointerUp,
        positionType: "fixed",
    });

    return { dragHandlers, isDragging };
};
